"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoints = void 0;
/* eslint-disable sort-keys */

var breakpoints = exports.breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1280,
    xl: 1920
  }
};